export default {
  head_scripts: {
    title: 'Scripturi head',
  },
  body_noscripts: {
    title: 'Noscripturi body',
    description: 'Inserați cod imediat după deschiderea body',
  },
  google_site_verification: {
    title: 'Verificare site Google',
    label: 'Cod de verificare site Google',
  },
  buttons: {
    save: 'Salvați',
  },
};
